import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import ModalContext from 'contexts/modalContext';
import { Modal } from 'components/elements';
import useModal from './ModalProviderHooks/useModal';

export default function ModalProvider({ children }) {
  const { showModal, handleModal, modalContent, options } = useModal();
  const location = useLocation();
  useEffect(() => {
    handleModal(false);
  }, [location]);
  const modalValues = useMemo(() => ({ showModal, handleModal, modalContent, options }), [showModal, handleModal, modalContent, options]);

  return (
    <ModalContext.Provider value={modalValues}>
      <Modal size={options.size} />
      {children}
    </ModalContext.Provider>
  );
}

ModalProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
};
